const productDepartments = [
  { id: -1, text: 'N/A' },
  { id: 1, text: 'Embroidery' },
  { id: 2, text: 'Dye sub' },
  { id: 3, text: 'Direct to garment' },
  { id: 4, text: 'Laser' },
  { id: 5, text: 'Diamond' },
  { id: 6, text: 'UV' },
  { id: 7, text: 'Fiber' },
  { id: 8, text: 'Heat stamp' },
];

const productTypes = [
  { id: 1, text: 'New Product' },
  { id: 2, text: 'Inventory' },
  { id: 3, text: 'Quotes' },
];

export const DepartmentConfig = {
  productDepartments,
  productTypes,
};
